import { render } from "./slideFour.vue?vue&type=template&id=70ff1a9c"
import script from "./slideFour.vue?vue&type=script&lang=js"
export * from "./slideFour.vue?vue&type=script&lang=js"

import "./slideFour.vue?vue&type=style&index=0&id=70ff1a9c&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__